import axios from 'axios'

export default class MailService {
  static async sendMail (mailType, emailId, clientId) {
    return axios
      .get(`${process.env.VUE_APP_INTERNAL_API_BASEURL}/test/mail/send/${mailType}/${emailId}?clientId=${clientId}`)
  }
}